<form [formGroup]="searchForm">
  <div class="input-group">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="fas fa-search"></i></span>
    </div>
    <input
      type="text"
      class="form-control"
      [placeholder]="placeholder"
      formControlName="searchTerm"
      name="searchTerm"
      autofocus
    />
  </div>
</form>
